import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLUListElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLUListElement
 */
export default class HTMLUListElement extends HTMLElement {}
